var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartfmLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 760,
    height: 207,
    viewBox: "0 0 760 207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.006,
    y1: 0.5,
    x2: 0.845,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20d1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1286ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-SMART_FM_LOGO"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 760,
    height: 207
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SMART_FM_LOGO",
    "data-name": "SMART FM_LOGO",
    clipPath: "url(#clip-SMART_FM_LOGO)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553",
    transform: "translate(-57 -621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Smart_Fm_sygnet",
    "data-name": "Smart Fm sygnet",
    transform: "translate(57 621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M179.272,32.981a103.89,103.89,0,0,0-8.689-7.747,134.867,134.867,0,0,0-56.251,6.979A74.339,74.339,0,1,1,53.583,53.525c.9-.907,1.832-1.787,2.771-2.638a148.031,148.031,0,0,1,89.386-40.327,103.413,103.413,0,1,0,33.533,22.421Z",
    transform: "translate(-2.757 -2.706)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    "data-name": "Group 540",
    transform: "translate(50.424 40.555)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(50.517 32.632)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-2",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(50.517 68.402)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-3",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(68.402 50.517)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-4",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(32.632 50.517)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-5",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(63.164 63.164)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-6",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(37.87 37.871)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-7",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(63.164 37.871)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-8",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(37.87 63.164)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-9",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(66.915 57.657)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-10",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(34.119 43.377)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-11",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(57.225 67.097)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-12",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(43.81 33.938)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-13",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(43.88 67.125)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-14",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(57.155 33.906)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-15",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(34.248 57.95)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-16",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(66.786 43.084)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-17",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(60.041 109.326)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-18",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(53.693 109.326)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-19",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(47.342 109.326)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-20",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(40.99 109.326)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-21",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(60.044 115.042)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-22",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(53.693 115.042)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-23",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(47.342 115.042)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-24",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(40.994 115.042)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-25",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(53.693 120.762)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-26",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(47.342 120.762)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-27",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(39.982 0.311)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-28",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(46.469 0.206)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-29",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(52.96 0.105)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-30",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(59.451)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-31",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(40.072 6.187)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-32",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(40.167 12.064)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-33",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(59.545 5.877)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-34",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(59.639 11.753)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-35",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(61.056 100.724)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-36",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(54.565 100.829)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-37",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(48.074 100.93)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-38",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(41.583 101.035)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-39",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(60.962 94.847)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-40",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(60.868 88.971)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-41",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(41.489 95.158)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-42",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(41.395 89.281)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-43",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(0.31 61.053)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-44",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(0.206 54.562)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-45",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(0.105 48.074)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-46",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(0 41.584)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-47",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(6.187 60.962)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-48",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(12.064 60.868)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-49",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(5.877 41.489)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-50",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(11.753 41.395)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-51",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(100.724 39.978)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-52",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(100.829 46.469)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-53",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(100.93 52.96)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-54",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(101.035 59.451)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-55",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(94.847 40.073)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-56",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(88.946 40.177)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-57",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(95.158 59.545)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-58",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(89.281 59.639)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-59",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(7.566 22.467)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-60",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(12.081 17.805)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-61",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(16.597 13.142)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-62",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(21.113 8.477)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-63",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(11.785 26.553)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-64",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(16.007 30.643)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-65",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(25.335 12.567)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-66",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(29.558 16.656)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-67",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(93.469 78.568)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-68",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(88.953 83.23)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-69",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(84.437 87.892)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-70",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(79.922 92.554)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-71",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(89.25 74.478)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-72",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(85.027 70.391)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-73",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(75.699 88.468)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-74",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(71.48 84.382)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-75",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(78.568 7.562)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-76",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(83.23 12.081)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-77",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(87.892 16.597)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-78",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(92.554 21.113)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-79",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(74.478 11.785)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-80",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(70.391 16)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-81",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(88.468 25.335)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-82",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(84.392 29.551)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-83",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(22.467 93.469)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-84",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(17.804 88.953)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-85",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(13.142 84.437)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-86",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(8.48 79.922)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-87",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(26.557 89.25)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-88",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(30.643 85.027)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-89",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(12.566 75.699)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-90",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(16.656 71.477)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-91",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(65.017 13.875)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-92",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(86.667 34.866)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-93",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(87.03 65.069)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-94",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(66.026 86.73)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-95",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(66.026 86.73)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-96",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(66.026 86.73)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-97",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(35.878 87.215)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-98",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(14.367 66.169)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-99",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(13.885 36.021)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-100",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(13.885 36.021)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386-101",
    "data-name": "Ellipse 386",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(34.862 14.364)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544",
    transform: "translate(314.494 666.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M61.893-24.57c0-11.7-7.254-18.369-17.55-22.113-2.574-1.053-8.541-3.159-12.051-4.563-3.627-1.4-8.19-3.276-8.19-8.19s4.446-7.254,10.53-7.254S47.97-63.18,52.65-58.5l8.073-13.221c-5.5-5.5-16.263-9.945-25.623-9.945s-16.731,2.574-21.294,6.435A22.736,22.736,0,0,0,5.382-57.564c0,7.6,2.808,12.285,6.318,15.561,3.51,3.393,7.605,4.914,9.594,5.85,2.691,1.17,8.775,3.276,12.285,4.563S43.056-28.2,43.056-22.7c0,5.382-4.68,8.307-10.764,8.307-6.2,0-15.21-4.095-21.06-10.179L1.872-10.764C8.424-4.68,18.837,1.4,30.537,1.4,46.215,1.4,61.893-7.137,61.893-24.57ZM161.109,0V-34.749c0-13.923-5.265-23.985-20.007-23.985-8.541,0-14.274,3.51-18.369,10.53-2.925-7.839-9.243-10.53-17.2-10.53a18.832,18.832,0,0,0-15.912,9.243l-.234.117.117-8.307H70.785V0h18.72V-29.6c0-7.956,2.808-13.806,9.36-13.806,6.084,0,7.722,4.914,7.722,12.051V0h18.72V-29.6c0-7.956,2.808-13.806,9.36-13.806,6.435,0,7.6,5.85,7.6,12.051V0Zm63.648,0V-32.526c0-18.72-10.413-26.208-28.431-26.208a56.789,56.789,0,0,0-24.687,5.85l4.914,12.168a36.85,36.85,0,0,1,17.667-5.148c7.488,0,11.817,3.159,11.817,9.243v1.287l-14.508.585c-10.647.468-22.464,4.8-22.464,17.667S179.829,1.287,190.008,1.287c9.36,0,14.04-4.914,16.5-7.371L206.856,0Zm-18.6-25.389v9.477a11.49,11.49,0,0,1-9.594,5.265c-5.148,0-8.775-2.691-8.775-7.137,0-4.329,3.393-6.786,9.126-7.02ZM275.3-57.681a13.464,13.464,0,0,0-5.85-1.053c-6.2,0-11,2.925-14.274,9.243h-.234l.117-8.19H236.34V0h18.72V-25.623c0-7.6,2.34-16.263,11.583-16.263a15.078,15.078,0,0,1,6.786,1.4h.819Zm43.641,14.274V-57.564H306.189V-73.242H287.352v15.678h-8.19v14.157h8.19V-21.06c0,13.221,3.159,22.347,18.135,22.347A50.662,50.662,0,0,0,318.825-.585l-.936-14.625a17.448,17.448,0,0,1-5.616,1.053c-5.733,0-6.084-3.51-6.084-8.541V-43.407Z",
    transform: "translate(-0.494 93.909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M55.368-33.757V-48.99H4.473V32.49H23.485V1.433H53.479V-13.8H23.485V-33.757ZM156.923,32.49,150.9-48.99H126.693L109.924,4.621h-.236l-17-53.611H68.594l-6.14,81.48H81.229l2.952-55.5h.354l17.595,55.5h15.115l17.477-55.5h.236l3.188,55.5Z",
    transform: "translate(345.584 62.312)",
    fill: "url(#linear-gradient-2)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartfmLogo);
export default __webpack_public_path__ + "static/media/smartfm_logo.3501fcaf4bee0706b71c79230cda15de.svg";
export { ForwardRef as ReactComponent };